import {SessionAvailabilityFormFields} from "../../session/availability";

export function BundleSessionAvailabilityFormFields() {
  return <SessionAvailabilityFormFields />;
}
